<template>
  <div>
    <input id="general" type="text" v-model="search_text" ref="search_box" />
    <a id="voice-micro" :class="{ listening: listening }" :disabled="listening"
      @click="get_voice(set_text, search)"></a>
    <a id="operator_y" @click="insert_operator(' Y ')">Y</a>
    <a id="operator_o" @click="insert_operator(' O ')">O</a>
    <a id="operator_no" @click="insert_operator('!')">NO</a>
    <a id="show_search_opcions" @click.stop="show_options">Opciones</a>
    <div id="search_options" v-show="options_visible" v-on-clickaway="hide_options">
      <input type="radio" id="all_texts" value="all" v-model="selected_query_field" />En todo
      <input type="radio" id="only_title" value="titles" v-model="selected_query_field" />Titulos
      <input type="radio" id="substring" value="substring" v-model="selected_query_format" />En todo
      <input type="radio" id="exacta" value="exacta" v-model="selected_query_format" />Titulos
    </div>
    <search-boolean-facet-vue :name="special_filter_name" :values="[filterValueReceived]"
      :facet="{}" :operator="'OR'" :sign="'POSITIVE'" v-if="itHasSpecialFilter(special_filter_name)"
      @update_filter="updateSpecialFilterValue(name, values)" />
    <button id="search_btn" @click="search">Buscar</button>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import mixins from 'common/mixins.js'
import search_mixin from 'common/mixins/search_mixin'
import MainSearchBox from 'components/forms/MainSearchBox';

export default {
  components: {
    'search-boolean-facet-vue': () => import(/* webpackChunkName: "[request]" */ "components/search/BooleanFacet")
  },
  mixins: [mixins.requests, search_mixin],
  name: "forms-perform-search-box-vue",
  props: {
    special_filter_name: {
      type: String, default: ''
    },
    special_filter_object: {
      type: Object, default: () => {}
    },
    redirecting: {
      type: Boolean, default: false
    }
  },
  extends: MainSearchBox,
  data() {
    return {
      selected_query_field: "all",
      selected_query_format: "substring",
      search_text: "",
      selected_filter: this.setDefaultFilter(),
      specialFilterObject: this.special_filter_object
    };
  },
  computed: {
    ...mapState("search", ["searchTokens", "queryFormat", "queryField", "specialFilter", "filters"]),
    filterValueReceived() {
      if(this.filters.length > 0)
        return this.filters[0].values[0]
      else
        return "false"
    }
  },
  methods: {
    ...mapActions("search", ["performSearch"]),
    ...mapMutations("search", [
      "setSearchTokens",
      "setQueryFormat",
      "setQueryField",
      "changeSpecialFilter",
      "setFilters",
      "resetGroupResults"
    ]),
    ...mapMutations('conversa', ['setConversaSearch']),
    set_text(text) {
      this.search_text = text
    },
    setDefaultFilter() {
      return [{
        mandatories_values: [],
        name: "",
        operator: "OR",
        sign: "POSITIVE",
        values: [""]
      }]
    },
    search() {
      this.resetGroupResults()
      if (this.search_redirect_to_document_detail(this.search_text, this.selected_query_format)) {
        this.emitRedirecting()
        return
      }

      this.setSearchTokens(this.search_text != "" ? [this.search_text] : [])
      this.setQueryFormat(this.selected_query_format)
      this.setQueryField(this.selected_query_field)
      this.performSearch()
    },
    applySpecialFilterObject() {
      if (this.specialFilterObject && this.specialFilterObject.values) {
        this.setFilters(
          [this.specialFilterObject]
        )
      }
    },
    updateSpecialFilterValue(name, values) {
      this.selected_filter = this.setDefaultFilter()
      if (values[0] == "true") {
        this.selected_filter[0].name = name
        this.selected_filter[0].values = values
      } else {
        this.selected_filter = []
      }
      this.setFilters(this.selected_filter)
      this.changeSpecialFilter()
      this.search()
    },
    itHasSpecialFilter(filter_name) {
      let result = filter_name != '' ? true : false
      return result
    },
    emitRedirecting() {
      this.$emit('update:redirecting', true)
    }
  },
  mounted() {
    this.applySpecialFilterObject()
    this.search_text = this.searchTokens && this.searchTokens.length > 0 ? this.searchTokens[0] : "";
    this.selected_query_format = this.queryFormat
    this.selected_query_field = this.queryField
  },
  watch: {
    search_text(newValue) {
      this.setConversaSearch(newValue)
    }
  }
}
</script>
